import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialMedia = () => {
  const socialChannels = [
    {
      id: 1,
      name: 'Facebook',
      icon: 'Facebook',
      handle: '@HondaPamulang',
      followers: '15.2K',
      description: 'Update produk terbaru, promo menarik, dan tips berkendara',
      url: 'https://facebook.com/hondapamulang',
      color: 'bg-blue-50 text-blue-600 hover:bg-blue-100',
      iconColor: '#1877F2',
    },
    {
      id: 2,
      name: 'Instagram',
      icon: 'Instagram',
      handle: '@hondapamulang',
      followers: '23.8K',
      description: 'Galeri foto motor, customer stories, dan behind the scenes',
      url: 'https://instagram.com/hondapamulang',
      color: 'bg-pink-50 text-pink-600 hover:bg-pink-100',
      iconColor: '#E4405F',
    },
    {
      id: 3,
      name: 'Twitter',
      icon: 'Twitter',
      handle: '@HondaPamulang',
      followers: '8.5K',
      description: 'Berita terkini, layanan pelanggan, dan informasi cepat',
      url: 'https://twitter.com/hondapamulang',
      color: 'bg-sky-50 text-sky-600 hover:bg-sky-100',
      iconColor: '#1DA1F2',
    },
    {
      id: 4,
      name: 'YouTube',
      icon: 'Youtube',
      handle: 'Honda Pamulang',
      followers: '12.3K',
      description: 'Review motor, tutorial perawatan, dan video testimoni',
      url: 'https://youtube.com/@hondapamulang',
      color: 'bg-red-50 text-red-600 hover:bg-red-100',
      iconColor: '#FF0000',
    },
    {
      id: 5,
      name: 'TikTok',
      icon: 'Music',
      handle: '@hondapamulang',
      followers: '31.2K',
      description: 'Konten kreatif, tips singkat, dan tren motor terkini',
      url: 'https://tiktok.com/@hondapamulang',
      color: 'bg-gray-50 text-gray-600 hover:bg-gray-100',
      iconColor: '#000000',
    },
    {
      id: 6,
      name: 'LinkedIn',
      icon: 'Linkedin',
      handle: 'Honda Pamulang',
      followers: '5.7K',
      description: 'Informasi karir, budaya perusahaan, dan berita bisnis',
      url: 'https://linkedin.com/company/hondapamulang',
      color: 'bg-indigo-50 text-indigo-600 hover:bg-indigo-100',
      iconColor: '#0A66C2',
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12 lg:mb-16" data-aos="fade-up" data-aos-delay="150">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            Ikuti Kami di Media Sosial
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Dapatkan update terbaru, promo eksklusif, dan tips berkendara melalui media sosial kami
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-12" data-aos="zoom-in" data-aos-delay="150">
          {socialChannels?.map((channel) => (
            <a
              key={channel?.id}
              href={channel?.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group bg-card rounded-xl p-6 md:p-8 border border-border transition-all duration-300 hover:shadow-card-hover ${channel?.color}`}
            >
              <div className="flex items-start justify-between mb-4 md:mb-6">
                <div className="flex items-center space-x-3 md:space-x-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white shadow-sm flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon name={channel?.icon} size={28} color={channel?.iconColor} />
                  </div>
                  <div>
                    <h3 className="text-base md:text-lg font-heading font-bold text-foreground">
                      {channel?.name}
                    </h3>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {channel?.handle}
                    </p>
                  </div>
                </div>

                <Icon 
                  name="ExternalLink" 
                  size={20} 
                  className="text-muted-foreground group-hover:text-primary transition-colors" 
                />
              </div>

              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed mb-4">
                {channel?.description}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="flex items-center space-x-2">
                  <Icon name="Users" size={16} className="text-muted-foreground" />
                  <span className="text-xs md:text-sm font-semibold text-foreground">
                    {channel?.followers} Followers
                  </span>
                </div>

                <span className="text-xs md:text-sm font-medium text-primary group-hover:text-accent transition-colors">
                  Ikuti →
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-gradient-to-br from-primary to-accent rounded-2xl p-6 md:p-8 lg:p-10 text-white text-center" data-aos="zoom-in-up" data-aos-delay="150" >
          <div className="max-w-3xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-4 md:mb-6">
              <Icon name="Bell" size={32} color="white" className="w-7 h-7 md:w-8 md:h-8" />
            </div>

            <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold mb-3 md:mb-4" >
              Jangan Lewatkan Update Terbaru
            </h3>

            <p className="text-sm md:text-base lg:text-lg text-white/90 leading-relaxed mb-6 md:mb-8">
              Ikuti media sosial kami untuk mendapatkan informasi promo eksklusif, peluncuran produk baru, tips berkendara, dan konten menarik lainnya
            </p>

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              {socialChannels?.slice(0, 4)?.map((channel) => (
                <a
                  key={channel?.id}
                  href={channel?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110 border border-white/20"
                  aria-label={channel?.name}
                >
                  <Icon name={channel?.icon} size={24} color="white" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;